import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import FolderSyncIndicator from '../FolderSyncIndicator';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';
var FolderCardContent = function (_a) {
    var className = _a.className, folder = _a.folder, _b = _a.folder, isPortfolioLinked = _b.isPortfolioLinked, subfolders = _b.subfolders, _c = _b.hasSubfolders, hasSubfoldersFromFolder = _c === void 0 ? !!(subfolders === null || subfolders === void 0 ? void 0 : subfolders.length) : _c, type = _b.type, totalDeviationCount = _a.totalDeviationCount, hasSubfoldersOverride = _a.hasSubfolders, isCurrentUserOwner = _a.isCurrentUserOwner, forceViewAsVisitor = _a.forceViewAsVisitor, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var emptyGallectionInfo = {
        gallery: 'folderCard.empty.gallery.info',
        collection: 'folderCard.empty.collection.info',
    };
    var hasSubfolders = hasSubfoldersOverride !== null && hasSubfoldersOverride !== void 0 ? hasSubfoldersOverride : hasSubfoldersFromFolder;
    var showPortfolioSync = isPortfolioLinked && isCurrentUserOwner;
    if (!width || !height) {
        return null;
    }
    if (totalDeviationCount === 0 && isCurrentUserOwner) {
        return (React.createElement("div", { className: folderCardStyles['empty-folder'], style: { width: width, height: height } },
            React.createElement(UnwatchIcon, { className: folderCardStyles['empty-icon'], size: IconSize.HUGE }),
            React.createElement("div", { className: folderCardStyles['empty-folder-info'] }, t(emptyGallectionInfo[type]))));
    }
    var isPremiumFolder = normalizePremiumFolderData(folder.premiumFolderData).isPremium;
    var isFolderThumbPublished = folder.thumb && folder.thumb.isPublished;
    var showBlurredThumbInfoToOwner = isCurrentUserOwner && isPremiumFolder && isFolderThumbPublished;
    // Force blur gallection thumb if the owner is viewing the page in View As A Visitor mode
    // But if the thumb comes from stash, do not blur it
    var forceBlur = isCurrentUserOwner &&
        isPremiumFolder &&
        forceViewAsVisitor &&
        isFolderThumbPublished;
    return (React.createElement("div", { className: className },
        (hasSubfolders || showPortfolioSync) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: folderCardStyles['subfolders-icon-underlay'] }),
            React.createElement("div", { className: folderCardStyles['top-right-icons'] },
                showPortfolioSync && React.createElement(FolderSyncIndicator, null),
                hasSubfolders && (React.createElement(SubfoldersIcon, { className: classnames(folderCardStyles['subfolders-icon'], folderCardStyles['wix-portfolio-sync-feature']) }))))),
        React.createElement(GallectionCoverDumbo, { width: width, height: height, gallection: folder, forceBlur: !!forceBlur }),
        showBlurredThumbInfoToOwner && (React.createElement("div", { className: folderCardStyles['top-right-icons'] },
            React.createElement(FolderCoverInfo, null)))));
};
export default FolderCardContent;
//# sourceMappingURL=FolderCardContent.js.map